<template>
  <svg
    :width="width"
    viewBox="0 0 77 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 76.0001V31.817C0 30.5716 0.580155 29.3971 1.5693 28.6403L36.5375 1.88422C37.9869 0.775168 40.0033 0.787849 41.4386 1.91504L75.4705 28.6399C76.4361 29.3982 77 30.558 77 31.7858V76.0001C77 78.2092 75.2091 80.0001 73 80.0001H4C1.79086 80.0001 0 78.2092 0 76.0001Z"
      fill="#293FD1"
    />
    <path
      d="M50.5 23.6481V23.6513V37.7073C50.5 38.65 49.7383 39.4116 48.7956 39.4116H28.2044C27.2616 39.4116 26.5 38.65 26.5 37.7073V23.6253C26.5 23.2172 26.6545 22.711 26.977 22.1141C27.2965 21.5228 27.7615 20.8782 28.3344 20.2031C29.4801 18.8529 31.0185 17.4261 32.5721 16.1175C34.123 14.8111 35.6757 13.6336 36.8417 12.7821C37.4244 12.3565 37.9098 12.0129 38.2491 11.776C38.3441 11.7097 38.4276 11.6517 38.4986 11.6027C38.5701 11.6525 38.6543 11.7115 38.7501 11.7791C39.0901 12.0187 39.5765 12.3661 40.1603 12.7959C41.3285 13.6561 42.8839 14.8442 44.4366 16.1588C45.9921 17.4757 47.5317 18.9084 48.6765 20.2578C49.249 20.9325 49.7129 21.5749 50.0306 22.1617C50.3517 22.7545 50.5025 23.2522 50.5 23.6481Z"
      stroke="white"
    />
    <path
      d="M35.6989 26.9965C35.4655 26.4778 35.1024 26.2963 34.506 26.2963H32.5091C31.6792 26.2963 31.0049 26.9706 31.0049 27.8004V30.316H32.0163V33.817H35.0246"
      stroke="white"
      stroke-miterlimit="10"
    />
    <path
      d="M33.4946 24.7919C34.3253 24.7919 34.9987 24.1184 34.9987 23.2877C34.9987 22.457 34.3253 21.7836 33.4946 21.7836C32.6639 21.7836 31.9904 22.457 31.9904 23.2877C31.9904 24.1184 32.6639 24.7919 33.4946 24.7919Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <path
      d="M41.3268 26.8412C41.5602 26.3225 41.8974 26.2706 42.4939 26.2706H44.4907C45.3206 26.2706 45.9949 26.9449 45.9949 27.7748V30.2903H44.9835V33.7914H41.9752"
      stroke="white"
      stroke-miterlimit="10"
    />
    <path
      d="M43.5039 24.7919C44.3346 24.7919 45.008 24.1184 45.008 23.2877C45.008 22.457 44.3346 21.7836 43.5039 21.7836C42.6732 21.7836 41.9998 22.457 41.9998 23.2877C41.9998 24.1184 42.6732 24.7919 43.5039 24.7919Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <path
      d="M40.0035 35.0098H36.9952V31.016H35.491V27.515C35.491 26.3998 36.3987 25.5181 37.4879 25.5181H39.4848C40.5999 25.5181 41.4817 26.4258 41.4817 27.515V31.016H39.9775V35.0098H40.0035Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <path
      d="M38.4995 24.0144C39.6024 24.0144 40.4964 23.1203 40.4964 22.0175C40.4964 20.9146 39.6024 20.0206 38.4995 20.0206C37.3967 20.0206 36.5027 20.9146 36.5027 22.0175C36.5027 23.1203 37.3967 24.0144 38.4995 24.0144Z"
      stroke="white"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <path
      d="M0 81V33.8288C0 33.0383 0.874094 32.5603 1.53967 32.987L39 57L0 81Z"
      fill="#1E65FF"
    />
    <path
      d="M77 33.8541L77 81L39 56.9804L75.4507 33.0185C76.1156 32.5814 77 33.0583 77 33.8541Z"
      :fill="primaryColor"
    />
    <path
      d="M36.813 57.4019L0 81H77L41.1702 57.4277C39.8503 56.5594 38.1431 56.5493 36.813 57.4019Z"
      fill="#3172FF"
    />
  </svg>
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
export default Vue.extend({
  name: "Digest",
  props: {
    width: { type: String, default: "81" },
  },
  data() {
    return {
      primaryColor: this.$vuetify.theme.themes.light.primary,
    }
  },
})
</script>
